import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-jia",
  "use": "icon-jia-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-jia\">\r\n<title>加</title>\r\n<desc>Created with Sketch.</desc>\r\n<path id=\"icon-jia_合并形状\" d=\"M7,7V5c0-0.552,0.448-1,1-1c0.553,0,1,0.448,1,1v2h2c0.553,0,1,0.448,1,1\r\n\tc0,0.553-0.447,1-1,1H9v2c0,0.553-0.447,1-1,1c-0.552,0-1-0.447-1-1V9H5C4.448,9,4,8.553,4,8c0-0.552,0.448-1,1-1H7z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/jia.svg
// module id = XMX/
// module chunks = 31